import { FC } from 'react'

import { IShipTpEvent } from '../domain/TransportPlanEvent'
import { TpTimestampRangeCtx, TTpTimestampRangeCtx } from '../service/TpTimestampRangeContext'
import { EventsDelaysRange } from './TpDelay'

type TTpRangeSameMonthCtx = {
  showDelay?: boolean
  useSingleLine?: boolean
}

type TTpRangeSameMonthProps = {
  range: string
  events: IShipTpEvent[]
} & TTpRangeSameMonthCtx

// 01 - 10. Feb 2018 (-6d - +3d)
export const LeanTpRangeSameMonth: FC<TTpRangeSameMonthProps> = (props) => {
  const { useSingleLine = false, showDelay = true, range, events } = props
  return (
    <span>
      <span style={{ whiteSpace: 'nowrap' }}>{range}</span>
      {!useSingleLine && <wbr />}
      {showDelay && <EventsDelaysRange events={events} />}
    </span>
  )
}

const mapCtxToProps = (ctx: TTpTimestampRangeCtx): Required<TTpRangeSameMonthCtx> => ({
  showDelay: ctx.showDelay,
  useSingleLine: ctx.useSingleLine,
})

const TpRangeSameMonthConsumer: FC<TTpRangeSameMonthProps> = (props) => (
  <TpTimestampRangeCtx.Consumer>
    {(ctx) => <LeanTpRangeSameMonth {...mapCtxToProps(ctx)} {...props} />}
  </TpTimestampRangeCtx.Consumer>
)

export const TpRangeSameMonth = TpRangeSameMonthConsumer
